/**
 * Initializes the accordion component
 * Sets height of accordion items based on content, once they open/close
 */
export function InitAccordion(){
    let $accordionItems = $('.accordion input[type=radio]');

    $accordionItems.off('click');
    $accordionItems.off('change');
    $accordionItems.on('click', function() {
        var $this = $(this);
        if ($this.attr('checked')) {
            var content = $this.parent().find('.accordion-content');
            content.css("height", $this.attr('checked') ? content[0].scrollHeight : 0);
            setTimeout(function(){
                $this.prop('checked', false);
                $this.attr('checked', false);
                $this.trigger('change');
            }, 20);
        } else {
            $this.attr('checked', true);
            var checkedItem = $('.accordion').find('[name="' + $this.prop('name') + '"]').not($this);
            checkedItem.each(function(nr, item){
                var $itItem = $(item);
                if($itItem.attr('checked')){
                    var content = $itItem.parent().find('.accordion-content');
                    content.css("height", content[0].scrollHeight);
                    setTimeout(function(){
                        $itItem.attr('checked', false);
                        $itItem.trigger('change');     
                    }, 0);
                }
            });
        }
    });

    $accordionItems.on('change', function(){
        var $this = $(this);
        var content = $this.parent().find('.accordion-content');
        content.css("height", $this.attr('checked') ? content[0].scrollHeight : 0);
        setTimeout(function(){
            content.css("height", $this.attr('checked') ? 'auto' : 0);
        }, 500);
    });
}